import { IValueViewModel, Pattern } from '../../models/index';
import { userFieldParser } from '../../common/helpers';

export const searchCriteria: Pattern<IValueViewModel>[] = [
    {
        label: 'Tag name',
        placeholder: 'Name of the tag',
        model: 't',
        property: 't',
        isMatch: (vm, regex) => {
            return regex.test(vm.tagName);
        }
    },
    {
        label: 'Identifier name',
        placeholder: 'Name of the identifier',
        model: 'i',
        property: 'i',
        isMatch: (vm, regex) => {
            return regex.test(vm.name);
        }
    },
    {
        label: 'Group',
        placeholder: 'Search pattern on group',
        model: 'g',
        property: 'g',
        isMatch: (vm, regex) => vm.groupList && vm.groupList.length
            && vm.groupList.filter(g => regex.test(g.absoluteName)).length > 0
    },
    {
        label: 'Unit',
        placeholder: 'Search pattern on unit (e.g. bar, °C)',
        model: 'u',
        property: 'u',
        isMatch: (vm, regex) => regex.test(vm.unitName)
    },
    {
        label: 'Comment',
        placeholder: 'Search pattern on comment',
        model: 'c',
        property: 'c',
        isMatch: (vm, regex) => regex.test(vm.shortComment)
    },
    {
        label: 'Variable',
        placeholder: 'Search pattern on group',
        model: 'v',
        property: 'v',
        isMatch: (vm, regex) => regex.test(vm.variableTypeName)
    },
    {
        property: 'ufk',
        label: 'User field',
        model: 'ufk',
        placeholder: 'Search pattern on user field key (e.g. BWART=42_AND_UNIT=KG_OR_MATNR=ABC )',
        isMatch: userFieldParser
    }
];